import {useLocale} from "next-intl";
import {useEffect} from "react";

export const useZendeskWidget = () => {
    const locale = useLocale();

    const onOpenWidget = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        zE("messenger:set", "locale", locale)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        zE('messenger', 'open');
    }

    useEffect(() => {
        if (window.zE) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-expect-error
            zE("messenger:set", "locale", locale)
        }
    }, [locale])

    return {
        onOpenWidget,
    }
};
